module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABN0lEQVR4AWJwL/ABtGfHRg7CQBiFI1fglD6ohWLIKUFNELoSlUC8DSjZewGxRgy/8Z5GmvnSG95ZCJD+tREwAqIEMGas2JFhKCdDxo4Vc4gAxoQNB/yiAxumxwMYbyQU+E0FCe9HAhgLDC5mWL4WwHghwb8s4SUNOC/+A3/IpzVCf/HqCEFAgv9IuhXAWOA/ttQD6kulBQiw2hIbdOq0T6XaE7YECiiYrgRs8GC2KwFHwICjKYAxw4OaWwLWwAFrS8B+549WKP5Ze0tAhosjVL90bgkwuDBCOU2tJaAI56j6HivCgHpE+8XrA0y2WuhXN1PfxPUI/dKc9cto3Xpykb3/B1n8V4neX+biv073/0ET/5Oyn4/6DrZV4m9sja3FAJu7Y3s9wAHHOGIKcMg3jlkDGgEjQOAPxi/DQTqLVO8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/drop_down.png
// module id = 41
// module chunks = 0